import { render, staticRenderFns } from "./VehicleTypeSelectedWarning.vue?vue&type=template&id=3069d70c&"
import script from "./VehicleTypeSelectedWarning.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeSelectedWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports